import { ILevelFilter, ILevel } from "../types/server.interface";
import { ISupplierLevelInfo } from "~/types/supplier.interface";

export const LEVEL_PRIORITY: Array<Record<string, number>> = [
  {
    region: 0,
    silver: 1,
    gold: 2,
    platinum: 3,
    vip: 4,
  },
  {
    region: 0,
    lite: 1,
    classic: 2,
    premium: 3,
    vip: 4,
  }
];

export const sortLevels = <T extends ILevelFilter | ILevel | ISupplierLevelInfo>(levels: T[], subscriptionModel: number): T[] => {
  const priorityMap = LEVEL_PRIORITY[subscriptionModel];

  return levels.sort((level1, level2) => {
    const priority1 = priorityMap[level1?.id] ?? -1;
    const priority2 = priorityMap[level2?.id] ?? -1;
    return priority1 - priority2;
  });
};

// define the highest level from the selected on the ui
export function getHighestLevel(levels: string[], subscriptionModel: number) {
  const priorityMap = LEVEL_PRIORITY[subscriptionModel];

  return levels.reduce((max, level) => {
    const priorityMax = priorityMap[max] ?? -1;
    const priorityLevel = priorityMap[level] ?? -1;
    return priorityLevel > priorityMax ? level : max;
  }, levels[0]);
}